import { Card } from '@sm/wds-react';
import React from 'react';
import { LogoWithText } from '../Logos';
import './captive-window.scss';
import Footer from './Footer';

export interface CaptiveWindowProps {}

const CaptiveWindow: React.FC<CaptiveWindowProps> = props => (
  <div className="sm-captive-window__page wds-flex wds-flex--y wds-flex--x-center">
    <div className="sm-captive-window__section">
      <header className="sm-logo__header">
        <LogoWithText className="sm-logo__logo" />
      </header>

      <Card {...props} />
    </div>
    <div className="sm-captive-window__section">
      <Footer />
    </div>
  </div>
);

export default CaptiveWindow;
